import { render } from "./ModalBackdrop.vue?vue&type=template&id=7ad847be"
import script from "./ModalBackdrop.vue?vue&type=script&lang=js"
export * from "./ModalBackdrop.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__